import { render, staticRenderFns } from "./ActiveStatusList.vue?vue&type=template&id=84c15a8a"
import script from "./ActiveStatusList.vue?vue&type=script&lang=js"
export * from "./ActiveStatusList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports